<template>
  <div class="bgkl">
    <van-config-provider :theme-vars="{navBarBackgroundColor: '#' + required.skin}">
      <van-nav-bar
          title="流量套餐"
          left-arrow
          :placeholder="true"
          :fixed="true"
          @click-left="toBack"
          v-if="rendered.isNav"
      />
    </van-config-provider>
    <div class="gray"></div>
    <div class="box">
      <div>
        <div class="tab_con">
          <ul class="box_ul">
            <li :style="{color: '#'+required.skin}">{{ rendered.title }}</li>
            <li>
              生效:成功办理后立即生效并提供流量，办理后不取消则长期有效。
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="gray"></div>
    <div class="box_t">
      <p class="p2">重复订购：可重复订购</p>
      <div class="top" style="display:flex;flex-direction:row;">
        <div class="p2" style="white-space: nowrap;">其他套餐:</div>
        <div class="top-item-box">
          <div
              v-for="(item,index) in rendered.list"
              :key="index"
              class="top-item-box-i"
              :class="{active:choosePlanStore.currentSelectIndex === index}"
              :style="{'border-color':'#'+required.skin,'background-color':choosePlanStore.currentSelectIndex === index ? '#'+required.skin:'white'}"

              @click="selectCombo(item,index)"
          >{{ renameCombo(item, index) }}
          </div>
        </div>
      </div>
    </div>
    <div class="gray"></div>
    <div class="box_s">
      <div class="box_s_ul">
        <ul>
          <li>当前已办最长时长套餐：{{ rendered.used }}</li>
        </ul>
      </div>
    </div>
    <div class="gray"></div>
    <div class="box_f">
      <div class="p2">产品详情</div>
      <ul style="text-align: left">
        <li>1，生效规则:成功办理后立即生效并提供流量，下个结算日起按结算日扣取费用及提供流量,办理后不取消则长期有效。</li>
        <li>2.套餐所含流量至结算日将自动清零。</li>
        <li>3.以上套餐所含流量不适用于中国港澳台。</li>
        <li>4.流量耗完后自动停止服务。</li>
      </ul>
    </div>
    <div class="gray"></div>
    <van-tabbar style="background: #EDEEEF">
      <div class="btn" :style="{'background-color':'#'+required.skin}" @click="doNow">
        立即办理
      </div>
    </van-tabbar>
  </div>
</template>

<script>
import {Dialog, Toast} from 'vant'
import {useRouter} from 'vue-router'
import {reactive, onMounted, toRefs, watchEffect} from 'vue'
import {comboUsed, createOrder} from "@/api"
// import {newPage, registerWindowEvent, setNavColor} from "@/utils/setupBridge"
import {WebViewBridge} from '@/utils/bridge'
import {
  setUrlParam,
  getLocalParam,
  getComboUnit,
  mapCacheParameters,
  mapURLParameters, mapRenderParameters
} from "@/utils/tool"
import {useFourGFlowStore} from "@/store/modules/FourGFlow";
import {useChoosePlanStore} from "@/store/modules/ChoosePlan";
import {useOrderListStore} from "@/store/modules/订单详情/orderList";

export default {
  name: "Combo",
  setup() {
    const fourGFlowStore = useFourGFlowStore()
    const webViewBridge = new WebViewBridge()
    //路由对象
    const router = useRouter()
    //必要参数 渲染参数
    let {defaultParams: required, renderedParams: rendered} = fourGFlowStore
    const choosePlanStore = useChoosePlanStore()
    const orderListStore = useOrderListStore()

    const state = reactive({
      //导航栏控制,默认显示
      isNav: true,
      //已选中套餐
      selected: 0,
      //套餐列表
      list: [],
      //套餐分组
      group: '',
      //套餐ID
      id: choosePlanStore.productId,
      //套餐名称
      title: '',
      //订单ID
      orderId: '',
      //在用套餐
      used: ''
    })

    //返回上一页
    const toBack = () => {
      router.go(-1)
    }

    //立即办理
    const doNow = () => {
      const {oemId, userId, iccId} = required      //经销商ID 用户ID 卡号
      const {title} = rendered // 套餐名称
      const {productId} = choosePlanStore      //预购套餐产品ID
      console.warn('立即办理', productId, title)
      if (!productId) return Toast("请先选择套餐")
      //办理确认
      Dialog.confirm({
        message: '是否确认购买 ' + title + '？',
      }).then(async () => {
        //创建订单
        const data = await createOrder(oemId, userId, iccId, productId)
        //跳转订单详情页面
        // orderListStore.selectedOrderId = data['id']
        orderListStore.setSelectedOrderId(data['id'])
        console.log("orderListStore success:",orderListStore)
        toOrder()
      }).catch(() => {
        // on cancel
      });
    }

    //跳转订单详情页
    const toOrder = () => Go('orderDetail')

    //页面跳转
    const Go = (route) => {
      const scenes = required.scenes
      const url = setUrlParam('/' + route, '')
      console.warn(scenes, 'to ' + route, url)
      if (scenes === 'APP') {
        webViewBridge.newPage(url)
      } else {
        router.push({path: route, replace: true})
      }
    }

    //初始化参数
    const init = () => {
      //查询URL参数
      const opt = router.currentRoute.value.query
      console.warn('页面URL传参', opt)
      //映射缓存参数
      mapCacheParameters(required, () => {
        //映射URL参数
        mapURLParameters(required, opt, () => {
          console.warn('页面参数映射完成,网站当前肤色', required.skin)
          //映射渲染参数
          //导航栏控制
          rendered.isNav = required.scenes === 'H5'
          console.warn(rendered.isNav ? 'H5' : 'APP' + '环境')
          // mapRenderParameters(rendered, opt, () => {
          //   console.warn('渲染参数映射完成')
          //   //导航栏控制
          //   rendered.isNav = required.scenes === 'H5'
          //   console.warn(rendered.isNav ? 'H5' : 'APP' + '环境')
          // })
        })
      })
    }

    //APP事件
    const reloadEvent = () => {
      webViewBridge.registerWindowEvent(() => {
        const skin = required.skin
        webViewBridge.setNavColor(skin)
      })
    }


    const mixProduct = (list) => {
      rendered.mixList = []
      const monthKey = 'basis_month'
      const yearKey = 'plus_year'
      const monthList = list[monthKey]
      const yearList = list[yearKey]

      if (monthList) {
        for (let i = 0; i < monthList.length; i++) {
          const item1 = monthList[i]
          const remark = item1['remark']
          if (remark.indexOf('3G月主套餐') !== -1) rendered.mixList.push(item1)
        }
      }

      if (yearList) {
        for (let j = 0; j < yearList.length; j++) {
          const item2 = yearList[j]
          const remark = item2['remark']
          if (remark.indexOf('120G年主套餐') === -1) rendered.mixList.push(item2)
        }
      }
      return rendered.mixList
    }

    //加载已开通套餐
    const reloadUsed = (group, id, expirationTime) => {
      //产品列表
      const productList = getLocalParam('product')
      //套餐列表
      const list = productList[group]
      if (list && list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          const item = list[i]
          const pid = item['id']
          if (String(pid) === String(id)) {
            const title = showComboName(item)
            rendered.used = title + ' 有效期：【' + expirationTime + '】'
          }
        }
      } else {
        rendered.used = '未办理'
      }
    }

    //重命名套餐名称
    const renameCombo = (item, index) => {
      //套餐ID
      const productId = item['id']
      //套餐名称
      const name = showComboName(item)
      // //默认选中
      if (productId === choosePlanStore.productId) {
        choosePlanStore.currentSelectIndex = index
        rendered.title = name
      }
      return name
    }

    //选择套餐
    const selectCombo = (item, index) => {
      //已选中套餐
      // rendered.selected = index
      choosePlanStore.currentSelectIndex = index
      //套餐ID
      // rendered.id = String(item.id)
      choosePlanStore.productId = item.id
      //套餐名称
      rendered.title = showComboName(item)
      console.log("selectCombo", choosePlanStore);
    }

    //套餐名称
    const showComboName = (item) => {
      const {remark, mode, price, group} = item
      let name;
      //套餐名称
      if (group === 'unlimited_month') {
        const text = '不限流量包'
        const subIndex = remark.indexOf(text)
        name = remark.substring(subIndex + text.length + 1, remark.indexOf('套餐'))
      } else {
        name = String(price) + '元/' + getComboUnit(mode)
      }
      return name
    }

    //业务处理
    const business = async () => {
      const iccId = required.iccId
      //产品列表
      const productList = getLocalParam('product')
      //套餐列表
      const list = rendered.isActive === 'mix_combo' ? mixProduct(productList) : productList[rendered.isActive]
      rendered.list = list ? list : []
      //查询开通套餐
      const data = await comboUsed(iccId)
      let {isOpen, info} = data
      if (!isOpen) return rendered.used = '未办理'
      let {id, group, expirationTime} = info
      reloadUsed(group, id, expirationTime)
    }

    //组件已安装
    onMounted(async () => {
      //初始化参数
      await webViewBridge.init()
      // console.log(choosePlanStore.productId,"xxxxx")
      if (!choosePlanStore.productId) choosePlanStore.productId = state.id

      const scenes = required.scenes
      rendered.isNav = required.scenes === 'H5'

      //检测环境
      if (scenes === 'APP') {
        console.warn('APP环境')
        //加载APP事件
        reloadEvent()
        //业务逻辑
        await business()
      } else {
        console.warn('H5环境')
        //业务逻辑
        await business()
      }
    })

    return {
      ...toRefs(state),
      required,
      rendered,
      toBack,
      selectCombo,
      renameCombo,
      doNow,
      choosePlanStore
    }

  }
}
</script>

<style scoped lang="scss">
.bgkl {
  width: 100%;
  height: 95vh;
  background-color: #EDEEEF;
}

p {
  font-size: 12px;
}

.box {
  background-color: white;
  width: 100%;
  height: 80px;
}

.box_ul {
  padding: 10px 0 0 10px;
  text-align: left
}

.box_ul li {
  list-style: none;
  font-size: 12px;
}

.gray {
  width: 100%;
  height: 7px;
}

.box_ul li:nth-child(1) {
  font-size: 16px;
}

.box_t {
  padding: 20px;
  width: calc(100% - 40px);
  background-color: white;
  font-size: 12px;
}

.box_s {
  width: 100%;
  height: 50px;
  background-color: white;
}

.box_f {
  padding: 10px 10px;
  width: calc(100% - 20px);
  height: 140px;
  background-color: white;
  font-size: 12px;
}

.box_f ul {
  padding: 15px;
}

.box_f ul li {
  width: 95%;
}

.btn {
  margin: 0 auto;
  width: 70%;
  height: 40px;
  line-height: 40px;
  background-color: #F7B916;
  text-align: center;
  color: white;
  border-radius: 20px;
}

///deep/ .van-checkbox__label {
//  font-size: 12px;
//}

.checkbox {
  margin-top: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 30%);
}

.tab_button {
  /*margin: -20px 0px 0px 80px;*/
}

.tab_button li {
  width: 66px;
  height: 18px;
  border: 1px solid #999;
  /*background: transparent;*/
  cursor: pointer;
  display: inline-block;
  margin-left: 10px;
  border-radius: 8px;
  color: #333;
  text-align: center;
}

.tab_button li.active {
  color: white;
}

.tab_con {
  width: 90%;
  color: #333;
  font-size: 12px;
  /*position: absolute;*/
  /*top: 50px;*/
}

.top {
  padding-top: 10px;
  display: flex;
  align-items: center;

  &-item-box {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: -10px;

    &-i {
      border-radius: 8px;
      border: 1px solid #999;
      padding: 3px 5px;
      margin: 10px 0 0 5px;
      transition: .3s;
    }

    &-i.active {
      color: white;
    }
  }
}

.box_s_ul ul li {
  float: left;
  font-size: 12px;
  margin: 17px;
}
</style>